"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRANSLATION = exports.TEXT_TYPE = exports.ICON_TYPE = void 0;
var ICON_TYPE = {
  normal: {
    color: 'greyDark',
    size: 'titleSmall'
  },
  default: {
    color: 'default',
    size: 'XSmall'
  },
  neutral: {
    color: 'neutral',
    size: 'titleSmall'
  }
};
exports.ICON_TYPE = ICON_TYPE;
var TEXT_TYPE = {
  normal: {
    type: 'textNormal',
    color: 'neutral'
  },
  default: {
    type: 'small',
    color: 'default'
  },
  light: {
    type: 'textNormal',
    color: 'greyDark'
  }
};
exports.TEXT_TYPE = TEXT_TYPE;
var TRANSLATION = {
  discountLabel: 'Prices are lower here than at the airport'
};
exports.TRANSLATION = TRANSLATION;